import React from "react";
import servicesImage from "../../assets/images/services.png";
import "./Services.css";

function Services() {
  const services = [
    {
      number: "01",
      title: "Premium Skincare Products",
      description:
        "We formulate science-backed skincare products using clinically recognized active ingredients and carefully selected botanical extracts. Every formulation is designed to deliver effective daily skincare while maintaining the highest standards of quality.",
    },
    {
      number: "02",
      title: "Research & Innovation",
      description:
        "Our products are developed through extensive laboratory research, combining modern cosmetic science with naturally derived ingredients. We are committed to continuous innovation to create safe, effective, and high-performance skincare solutions.",
    },
    {
      number: "03",
      title: "Quality Assurance",
      description:
        "Each product is manufactured under strict quality control procedures using premium ingredients to ensure consistency, safety, and customer satisfaction.",
    },
    {
      number: "04",
      title: "Customer Support",
      description:
        "Our dedicated support team is available to answer product-related questions, provide guidance on product usage, and assist customers before and after purchase.",
    },
    {
      number: "05",
      title: "Skincare Guidance",
      description:
        "We help customers choose products that best suit their skin type and skincare goals through educational content and personalized recommendations.",
    },
    {
      number: "06",
      title: "Online Shopping & Nationwide Delivery",
      description:
        "Enjoy a secure online shopping experience with convenient ordering and reliable delivery across Pakistan.",
    },
  ];

  const handleProductsClick = () => {
    window.history.pushState({}, "", "/products");
    window.dispatchEvent(new PopStateEvent("popstate"));
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="services-page">
      {/* HERO */}
      <section
        className="services-hero"
        style={{
          backgroundImage: `url(${servicesImage})`,
        }}
      >
        <div className="services-hero-overlay"></div>
        <div className="services-hero-content">
          <h1>Our Services</h1>
          <p>Science-backed Solutions &amp; Premium Care</p>
        </div>
      </section>

      {/* PHILOSOPHY INTRO */}
      <section className="services-philosophy">
        <div className="services-container">
          <div className="services-eyebrow">OUR PHILOSOPHY</div>
          <h2>Our Services</h2>
          <p className="services-intro">
            At YourCare, we combine scientific research with premium skincare
            ingredients to develop products that support healthy, radiant skin.
            Our services are centered on providing high-quality skincare
            solutions and an exceptional customer experience.
          </p>
        </div>
      </section>

      {/* SERVICES GRID */}
      <section className="services-list-section">
        <div className="services-container">
          <div className="services-grid">
            {services.map((service) => (
              <article className="service-card" key={service.number}>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* BOTTOM CTA */}
      <section
        className="services-cta"
        style={{
          backgroundImage: `url(${servicesImage})`,
        }}
      >
        <div className="services-cta-overlay"></div>
        <div className="services-container services-cta-content">
          <div className="services-eyebrow">YOUR CARE</div>
          <h2>Care that clicks.</h2>
          <p>
            Discover thoughtfully developed skincare solutions designed for your
            everyday care.
          </p>
          <button
            type="button"
            className="services-cta-button"
            onClick={handleProductsClick}
          >
            Explore Our Products <span>→</span>
          </button>
        </div>
      </section>
    </div>
  );
}

export default Services;